import { useTranslation } from "react-i18next";
import { Textarea } from "@mantine/core";

import { useCreateCampaignInquiryFormContext } from "./formContext";

export interface CreateCampaignInquiryAdditionalNotesFormProps {}
export const CreateCampaignInquiryAdditionalNotesForm = ({}: CreateCampaignInquiryAdditionalNotesFormProps) => {
    const { t } = useTranslation(["common"]);

    const createCampaignInquiryForm = useCreateCampaignInquiryFormContext();

    return (
        <Textarea
            {...createCampaignInquiryForm.getInputProps("additionalNotes")}
            mb="xs"
            label={t("campaigninquiry_additionalnotes_description")}
            placeholder={t("campaigninquiry_additionalnotes_placeholder")}
            minRows={8}
        />
    );
};
